export default "__VITE_ASSET__8dfa170f__"